import { useQuery, UseQueryResult } from 'react-query'

import { fetchCountries } from './services'
import { CountriesType } from './types'

export default function useCountriesQuery(): UseQueryResult<CountriesType> {
   return useQuery('countries', fetchCountries, { staleTime: 60 * (60 * 1000) })
}
